import { makeStyles } from "@material-ui/core";

const styles = makeStyles(({ palette }) => ({
  stepWrapperIndex: {
    fontWeight: 500,
    width: "24px",
    height: "24px !important",
    flexShrink: 0,
    borderRadius: "12px",
    backgroundColor: palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  stepWrapperLeftDivider: {
    width: "1px",
    height: "100%",
    backgroundColor: palette.separator.main,
  },
}));
export default styles;
